import React from "react";
import { TransformedProduct } from "../../../types/productApiTypes";
import ProductPriceDisplay from "../ProductPriceDisplay";
import ReferenceCodes from "../ReferenceCodes";

interface CardContentProps {
  product: TransformedProduct;
  view: "grid" | "list";
}

/**
 * Renders the main content of the card: category, name, description (list only), and price.
 */
const CardContent: React.FC<CardContentProps> = ({ product, view }) => {
  const firstCategory = product.enrichedCategories?.[0]?.name;

  return (
    <>
      {firstCategory && (
        <p className="product-card__category">{firstCategory}</p>
      )}
      <h3 className="product-card__name">
        <a href={product.permalink}>{product.name}</a>
      </h3>
      <ReferenceCodes product={product} matchedOnly />
      {view === "list" && product.shortDescription && (
        <p
          className="product-card__description"
          dangerouslySetInnerHTML={{ __html: product.shortDescription }}
        ></p>
      )}
      {/* We pass the BEM element class for positioning, but styling is largely handled by .product-price */}
      <ProductPriceDisplay product={product} className="product-card__price" />
    </>
  );
};

export default CardContent;
